import React, {Component} from 'react'
import { Link } from 'react-router-dom'
import {connect, useDispatch} from "react-redux";
import {SET_MENUHEADER} from "../../../actions/types";
import { Trans} from 'react-i18next';


class Welcome extends Component {
  constructor(props) {
    super(props);

    this.state = {
      username: "",
      password: "",
      loading: false,
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }
/*
dispatch({type: SET_MENUHEADER, payload: {menuactive: 'productpay', menulocation: '/productpay/none'},})
*/
  render() {
    const {dispatch} = this.props;

    // {t('testMsg')}
    return (
        <main role="main" className="omp-marging-body">
          <div className="badge-secondary pt-5 pb-5">
            <div className="container-fluid">
              <div className="row pt-3 pb-3">
                <div className="col-lg-7">
                  <h2 className="display-3">Orange Money School Fees</h2>
                  <p className="lead" align="">
                    <Trans>page_welcome_title_description</Trans>
                  </p>
                </div>
                <div className="col-lg-5 mt-1 mb-1">
                  {/* assets/images/discovery.svg */}
                  <img src="assets/images/logo_om_3_white.png" alt="" className="img-fluid" loading="lazy" />
                </div>
              </div>
            </div>
          </div>

          <div className="omp-bg-light pt-5 pb-5">
            <div className="container-fluid">
              <h1 className="display-3 text-center mb-3"><Trans>page_welcome_paiementscolaritexamen</Trans></h1>
              <div className="row">
                <div className="col-lg-4 col-md-4 col-sm-12">
                  <div className="jumbotron">
                    <i className="display-2 text-primary fa fa-book-reader mb-3" />
                    <h1 className="h3"><Trans>page_welcome_feescolaritexamen</Trans></h1>
                    <p className="lead"><Trans>page_welcome_feescolaritexamen_description</Trans></p>
                    <hr className="my-3"/>
                    <Link className="btn btn-primary" onClick={(e) => {dispatch({type: SET_MENUHEADER, payload: {menuactive: 'productpay', menulocation: '/productpay/none'},})}} to="/productpay/none">
                      <Trans>page_welcome_payfeescolaritexamen</Trans>
                    </Link>
                  </div>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-6">
                  <div className="jumbotron">
                    <i className="display-2 text-primary fa fa-search-dollar mb-3" />
                    <h1 className="h3"><Trans>header_menu_findapayment</Trans></h1>
                    <p className="lead"><Trans>header_menu_findapayment_description</Trans></p>
                    <hr className="my-3"/>
                    <Link className="btn btn-primary" onClick={(e) => {dispatch({type: SET_MENUHEADER, payload: {menuactive: 'payment', menulocation: '/payment'},})}} to="/payment">
                      <Trans>header_menu_findpayment</Trans>
                    </Link>
                  </div>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-6">
                  <div className="jumbotron">
                    <i className="display-2 text-primary fa fa-building mb-3" />
                    <h1 className="h3"><Trans>header_menu_getschoolcode</Trans></h1>
                    <p className="lead"><Trans>header_menu_getschoolcode_description</Trans></p>
                    <hr className="my-3"/>
                    <Link className="btn btn-primary" onClick={(e) => {dispatch({type: SET_MENUHEADER, payload: {menuactive: 'school', menulocation: '/school'},})}} to="/school">
                      <Trans>header_menu_getcode</Trans>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="container-fluid pt-5 pb-5">
            <div className="row">
              <div className="col-lg-5 col-md-5 col-sm-12 my-auto">
                <div className="col-lg-8 col-md-10 col-sm-8 col-8 mx-auto text-center">
                  <img src="assets/images/logo_groupe_sabc.png" alt="" className="col-12 img-fluid" loading="lazy" />
                </div>
                <div className="col-lg-8 col-md-10 col-sm-8 col-8 mx-auto text-center">
                  <img src="assets/images/logo_om_horizontal_blanc.png" alt="" className="col-12 img-fluid" loading="lazy" />
                </div>
              </div>
              <div className="col-lg-7 col-md-7 col-sm-12 align-self-start mt-2 mt-md-0 mt-lg-0">
                <h1 align="left"><Trans>header_menu_getinfospaymenttuitionexam</Trans></h1>
                <p className="lead" align=""><Trans>header_menu_getinfospaymenttuitionexam_description</Trans>&nbsp;<Link onClick={(e) => {dispatch({type: SET_MENUHEADER, payload: {menuactive: 'payment', menulocation: '/payment'},})}} className="" to="/payment"><Trans>cliquerici</Trans></Link>.</p>
                <div className="mt-2">
                  <Link className="btn btn-primary mr-2 mt-1 mb-3" onClick={(e) => {dispatch({type: SET_MENUHEADER, payload: {menuactive: 'payment', menulocation: '/payment'},})}} to="/payment">
                    <Trans>header_menu_findpayment</Trans>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </main>
    )
  }
}

function mapStateToProps(state) {
  const { message } = state.message;
  return {
    message
  };
}

// const MapLangTranslate = () => {
//   const { t, i18n } = useTranslation();
//
//   return { t, i18n };
// };

export default connect(mapStateToProps)(Welcome);

// export default Login;
